import { Maybe, Role, ClinicUserVetInfoFragment } from 'shared/types/graphql';

const ACCEPTED_EMAIL_DOMAINS = Object.freeze(['gettelevet.com', 'televet.com', 'otto.vet']);

export const hasCompanyEmail = (clinicUserEmail: string | undefined): boolean => {
  if (!clinicUserEmail || typeof clinicUserEmail != 'string') {
    return false;
  }

  const clinicUsersEmailDomain = clinicUserEmail.split('@')[1];
  return ACCEPTED_EMAIL_DOMAINS.includes(clinicUsersEmailDomain);
};

export const hasClinicAdminRole = (
  userClinicRoles: Maybe<ClinicUserVetInfoFragment['roles']> | undefined,
  clinicId: string | undefined,
): boolean => {
  if (!userClinicRoles || !Array.isArray(userClinicRoles || !clinicId)) {
    return false;
  }

  return userClinicRoles.some((role) => role.role === Role.Admin && role.clinic && role.clinic.id === clinicId);
};

export const hasTeletriageRole = (
  userClinicRoles: Maybe<ClinicUserVetInfoFragment['roles']> | undefined,
  clinicId: string | undefined,
): boolean => {
  if (!userClinicRoles || !Array.isArray(userClinicRoles || !clinicId)) {
    return false;
  }

  return userClinicRoles.some(
    (role) => role.role === Role.TeletriageAgent && role.clinic && role.clinic.id === clinicId,
  );
};
